import { useState, useEffect } from "react";

import moment from "moment";

import { doc, collection, query, where, onSnapshot } from "firebase/firestore";

// import { doc, getDoc } from "firebase/firestore";

import { useParams, Link, useHistory } from "react-router-dom";
import { firestore } from "../firebase";
import firebase from "firebase/compat/app";
import { useUserProvider } from "../context/UserProvider";
import { collectIdsAndDocs } from "../utils";

// import {
//   existingField_before_stacked,
//   existingField_before_side,
//   existingField_after_stacked,
//   existingField_after_side,
// } from "./WallExistingFields";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import TimelapseIcon from "@mui/icons-material/Timelapse";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import EditIcon from "@mui/icons-material/Edit";

import {
  Button,
  MenuItem,
  Box,
  Grid,
  useMediaQuery,
  Stack,
  Divider,
  Typography,
  Tab,
  Tabs,
  Chip,
} from "@mui/material";
import Sites from "./Sites";

import WallDetail from "./WallDetail";
import Measurements from "./Measurements";

const tabs = [
  { label: "Details", value: "details" },
  { label: "Measurements", value: "measurements" },
];

function HeaderSingleWall({
  id: wallId,
  siteId: siteId,
  site,
  props,
  formData,
  wall,
  createdAt,
  noteTest,
  siteStreet,
  siteNumber,
}) {
  const existingField_before_stacked = [
    // Horizontal Wall (Before Works)
    formData.horizontalWallOverlay,
    formData.horizontalWallCoating,
    formData.horizontalWallStructure,
    formData.horizontalWallCeiling,
    formData.horizontalWallSurface,
    formData.horizontalWallNotes,
    // Stacked Room 1 (Before Works)
    formData.stackedRoom1Name,
    formData.stackedRoom1TypeOf,
    formData.stackedRoom1Volume,
    formData.stackedRoom1LateralWall1,
    formData.stackedRoom1LateralWall2,
    formData.stackedRoom1LateralWall3,
    formData.stackedRoom1LateralWall4,
    formData.stackedRoom1Notes,
    // Stacked Room 2 (Before Works)
    formData.stackedRoom2Name,
    formData.stackedRoom2TypeOf,
    formData.stackedRoom2Volume,
    formData.stackedRoom2LateralWall1,
    formData.stackedRoom2LateralWall2,
    formData.stackedRoom2LateralWall3,
    formData.stackedRoom2LateralWall4,
    formData.stackedRoom2Notes,
  ];
  const existingField_before_side = [
    // Vertical Wall (Before Works)
    formData.verticalWallCoatingSideRoom1,
    formData.verticalWallStructure,
    formData.verticalWallCoatingSideRoom2,
    formData.verticalWallSurface,
    formData.verticalWallNotes,
    // Side Room 1 (Before Works)
    formData.sideRoom1Name,
    formData.sideRoom1TypeOf,
    formData.sideRoom1Volume,
    formData.sideRoom1LateralWall1,
    formData.sideRoom1LateralWall2,
    formData.sideRoom1Ceiling,
    formData.sideRoom1CeilingStructure,
    formData.sideRoom1FloorCoating,
    formData.sideRoom1FloorStructure,
    formData.sideRoom1Notes,
    // Side Room 2 (Before Works)
    formData.sideRoom2Name,
    formData.sideRoom2TypeOf,
    formData.sideRoom2Volume,
    formData.sideRoom2LateralWall1,
    formData.sideRoom2LateralWall2,
    formData.sideRoom2Ceiling,
    formData.sideRoom2CeilingStructure,
    formData.sideRoom2FloorCoating,
    formData.sideRoom2FloorStructure,
    formData.sideRoom2Notes,
  ];
  const existingField_after_stacked = [
    // Horizontal Wall (After Works)
    formData.horizontalWallOverlay,
    // formData.horizontalWallOverlayInterventions,
    formData.horizontalWallCoating,
    // formData.horizontalWallCoatingInterventions,
    formData.horizontalWallStructure,
    // formData.horizontalWallStructureInterventions,
    formData.horizontalWallCeiling,
    // formData.horizontalWallCeilingInterventions,
    formData.horizontalWallSurface,
    formData.horizontalWallNotes,
    // Stacked Room 1 (After Works)
    formData.stackedRoom1Name,
    formData.stackedRoom1TypeOf,
    formData.stackedRoom1Volume,
    formData.stackedRoom1LateralWall1,
    formData.stackedRoom1LateralWall2,
    formData.stackedRoom1LateralWall3,
    formData.stackedRoom1LateralWall4,
    formData.stackedRoom1Notes,
    // Stacked Room 2 (After Works)
    formData.stackedRoom2Name,
    formData.stackedRoom2TypeOf,
    formData.stackedRoom2Volume,
    formData.stackedRoom2LateralWall1,
    formData.stackedRoom2LateralWall2,
    formData.stackedRoom2LateralWall3,
    formData.stackedRoom2LateralWall4,
    formData.stackedRoom2Notes,
  ];
  const existingField_after_side = [
    // Vertical Wall (After Works)
    formData.verticalWallCoatingSideRoom1,
    // formData.verticalWallCoatingSideRoom1Interventions,
    formData.verticalWallStructure,
    // formData.verticalWallStructureInterventions,
    formData.verticalWallCoatingSideRoom2,
    // formData.verticalWallCoatingSideRoom2Interventions,
    formData.verticalWallSurface,
    formData.verticalWallNotes,
    // Side Room 1 (After Works)
    formData.sideRoom1Name,
    formData.sideRoom1TypeOf,
    formData.sideRoom1Volume,
    formData.sideRoom1LateralWall1,
    formData.sideRoom1LateralWall2,
    formData.sideRoom1Ceiling,
    formData.sideRoom1CeilingStructure,
    formData.sideRoom1FloorCoating,
    formData.sideRoom1FloorStructure,
    formData.sideRoom1Notes,
    // Side Room 2 (After Works)
    formData.sideRoom2Name,
    formData.sideRoom2TypeOf,
    formData.sideRoom2Volume,
    formData.sideRoom2LateralWall1,
    formData.sideRoom2LateralWall2,
    formData.sideRoom2Ceiling,
    formData.sideRoom2CeilingStructure,
    formData.sideRoom2FloorCoating,
    formData.sideRoom2FloorStructure,
    formData.sideRoom2Notes,
  ];

  function isEmptyString(operand) {
    return operand != "" ? "full" : "empty";
  }

  function isEmpty(current) {
    return isEmptyString(current) === "full" ? true : false;
  }

  const [currentTab, setCurrentTab] = useState("details");

  const [measurements, setMeasurements] = useState([]);
  // const { id } = useParams();
  const { user } = useUserProvider();

  // const siteRef = firestore.doc(`sites/${siteId}`);
  // const wallsRef = siteRef.collection("walls");

  // const siteRef = firestore.doc(`sites/${siteId}`);
  const wallRef = firestore.doc(`sites/${siteId}/walls/${wallId}`);
  const measurementsRef = wallRef.collection("measurements");

  let unsubscribeFromMeasurement = null;

  useEffect(() => {
    unsubscribeFromMeasurement = measurementsRef.onSnapshot((snapshot) => {
      const measurements = snapshot.docs.map(collectIdsAndDocs);
      setMeasurements(measurements);
    });

    return () => {
      unsubscribeFromMeasurement();
    };
  }, []);

  // const wallRef = wallsRef.doc(`walls/${id}`);
  // const wallRef = firestore.doc(`sites/mdfAar5ZWmIbVJ9sdOfu/walls/${id}`);

  // let unsubscribeFromWall = null;

  // useEffect(() => {
  //   unsubscribeFromWall = wallRef.onSnapshot((snapshot) => {
  //     const wall = collectIdsAndDocs(snapshot);
  //     setWall(wall);
  //   });
  //   return () => {
  //     unsubscribeFromWall();
  //   };
  // }, []);

  const handleTabsChange = (event, value) => {
    setCurrentTab(value);
  };

  const { nanoseconds, seconds } = createdAt !== null && createdAt;
  var timestamp = { nanoseconds, seconds };
  const dateTime = new Date(timestamp?.seconds * 1000);

  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.only("xs"));

  return (
    <Box sx={{ pb: 0 }}>
      <Box sx={{ mt: -2, mb: 2 }}>
        <MenuItem
          className="backlink"
          component={Link}
          sx={{
            p: "0",
          }}
          to={`/sites/${siteId}`}
          // to="/sites/mdfAar5ZWmIbVJ9sdOfu"
          // to={`/sites/${id}`}s
        >
          <Grid container>
            <Grid
              item
              sx={{
                alignItems: "center",
                display: "flex",
                overflow: "hidden",
                pr: ".5em",
              }}
            >
              <ArrowBackIcon fontSize="small" />
            </Grid>
            <Grid
              item
              sx={{
                alignItems: "center",
                display: "flex",
                overflow: "hidden",
              }}
            >
              <Typography variant="subtitle2">
                {siteStreet}, {siteNumber}
              </Typography>
            </Grid>
          </Grid>
        </MenuItem>
      </Box>
      <Grid container justifyContent="space-between" spacing={3}>
        <Grid
          item
          sx={{
            alignItems: "center",
            display: "flex",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              mr: 2,
              p: 1,
              backgroundColor: (theme) =>
                theme.palette.mode === "dark" ? "#037AF6" : "#3399ff",
              borderRadius: 2,
              maxWidth: "fit-content",
            }}
          >
            <Typography align="center" color="#fff" variant="subtitle2">
              {moment(dateTime).format("MMM").toUpperCase()}
            </Typography>
            <Typography align="center" color="#fff" variant="h6">
              {moment(dateTime).format("DD").toUpperCase()}
            </Typography>
          </Box>
          <div>
            <Typography variant={isSmallScreen ? "h5" : "h4"}>
              {formData.registrationPeriod === "Before Works" &&
              formData.roomDisposalDependingBeforeWorks === "Stacked Rooms"
                ? `${formData.stackedRoom1Name} / ${formData.stackedRoom2Name}`
                : formData.registrationPeriod === "Before Works" &&
                  formData.roomDisposalDependingBeforeWorks ===
                    "Side By Side Rooms"
                ? `${formData.sideRoom1Name} / ${formData.sideRoom2Name}`
                : formData.registrationPeriod === "After Works" &&
                  formData.roomDisposalDependingAfterWorks === "Stacked Rooms"
                ? `${formData.stackedRoom1Name} / ${formData.stackedRoom2Name}`
                : formData.registrationPeriod === "After Works" &&
                  formData.roomDisposalDependingAfterWorks ===
                    "Side By Side Rooms"
                ? `${formData.sideRoom1Name} / ${formData.sideRoom2Name}`
                : "error"}
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              {formData.registrationPeriod === "Before Works" &&
              formData.roomDisposalDependingBeforeWorks === "Stacked Rooms" &&
              // existingField_before_stacked.every != undefined &&

              existingField_before_stacked.every(isEmpty) ? (
                <CheckCircleIcon fontSize="small" color="primary" />
              ) : formData.registrationPeriod === "Before Works" &&
                formData.roomDisposalDependingBeforeWorks ===
                  "Side By Side Rooms" &&
                // existingField_before_side.every != undefined &&
                existingField_before_side.every(isEmpty) ? (
                <CheckCircleIcon fontSize="small" color="primary" />
              ) : formData.registrationPeriod === "After Works" &&
                formData.roomDisposalDependingAfterWorks === "Stacked Rooms" &&
                // existingField_after_stacked.every != undefined &&
                existingField_after_stacked.every(isEmpty) ? (
                <CheckCircleIcon fontSize="small" color="primary" />
              ) : formData.registrationPeriod === "After Works" &&
                formData.roomDisposalDependingAfterWorks ===
                  "Side By Side Rooms" &&
                // existingField_after_side.every != undefined &&
                existingField_after_side.every(isEmpty) ? (
                <CheckCircleIcon fontSize="small" color="primary" />
              ) : (
                <TimelapseIcon fontSize="small" sx={{ color: "#8D9EB7" }} />
              )}
              <Typography variant="subtitle2" sx={{ ml: 1 }}>
                Wall
              </Typography>
              <Typography
                // color="textSecondary"
                variant="subtitle2"
                sx={{
                  ml: 1,
                  color: (theme) =>
                    theme.palette.mode === "dark"
                      ? "rgb(128, 191, 255)"
                      : "#1b78d5",
                }}
              >
                {formData.registrationPeriod}
              </Typography>
              <Typography variant="subtitle2" sx={{ ml: 1 }}>
                {formData.roomDisposalDependingBeforeWorks ||
                  formData.roomDisposalDependingAfterWorks}
              </Typography>
            </Box>
          </div>
        </Grid>
        <Grid item>
          <Stack direction="row" spacing={2}>
            {!user ? (
              <Link to="/login" style={{ textDecoration: "none" }}>
                <Button
                  component="a"
                  // endIcon={<EditIcon fontSize="small" />}
                  sx={{ m: 1 }}
                  variant="outlined"
                  size="small"
                >
                  Sign in to add a new wall
                </Button>
              </Link>
            ) : (
              <>
                <Link
                  to={{
                    pathname: `/editWall/${wallId}/`,
                    state: { siteId },
                  }}
                  style={{ textDecoration: "none" }}
                >
                  <Button
                    component="a"
                    endIcon={<EditIcon fontSize="small" />}
                    sx={{ mt: 1 }}
                    variant="outlined"
                    className="outlined_2"
                    size="small"
                  >
                    Edit wall
                  </Button>
                </Link>
                <Link
                  to={{
                    pathname: `/addnewmeasurement/${wallId}/`,
                    state: { siteId, wallId },
                  }}
                  style={{ textDecoration: "none" }}
                >
                  <Button
                    component="a"
                    endIcon={<AddIcon fontSize="small" />}
                    sx={{ m: 1 }}
                    variant="contained"
                    className="contained_2"
                    size="small"
                  >
                    NEW MEASUREMENT
                  </Button>
                </Link>
              </>
            )}
          </Stack>
        </Grid>
      </Grid>
      <Tabs
        indicatorColor="primary"
        onChange={handleTabsChange}
        scrollButtons="auto"
        textColor="primary"
        value={currentTab}
        variant="scrollable"
        sx={{ mt: 3 }}
      >
        {tabs.map((tab) => (
          <Tab
            sx={{ color: "textSecondary" }}
            key={tab.value}
            label={tab.label}
            value={tab.value}
            // component={Link}
            // to={`/walls/${wallId}/${tab.value}`}
          />
        ))}
      </Tabs>
      <Divider sx={{ mb: 3 }} />
      {currentTab === "details" && <WallDetail formData={formData} {...wall} />}
      {/* {currentTab === "measurements" && <Measurements />} */}
      {currentTab === "measurements" && (
        <Measurements
          measurements={measurements}
          measurementsRef={measurementsRef}
          {...measurements}
          {...wall}
          siteId={siteId}
          wallId={wallId}
          formData={formData}
        />
      )}
    </Box>
  );
}

export default HeaderSingleWall;
